(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ls-enquiry-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const allowedWorkshops = new Set(['india-2026', 'iraq-2027', 'syria-2027']);
    const allowedTopics = new Set(['general', 'commissions', ...allowedWorkshops]);
    const initialise = (root = document) => {
      root.querySelectorAll('[data-ls-enquiry]').forEach((section) => {
        if (section.dataset.enquiryReady === 'true') return;
        const form = section.querySelector('form');
        const select = section.querySelector('[data-enquiry-topic]');
        if (!form || !select) return;
        section.dataset.enquiryReady = 'true';
        const state = section.querySelector('[data-enquiry-state]')?.dataset.enquiryState;
        const storageKey = `ls-enquiry-topic:${form.id}`;
        const options = Array.from(select.options);
        const selectTopic = (key) => {
          if (!allowedTopics.has(key)) return false;
          const option = options.find((item) => item.dataset.topicKey === key);
          if (!option) return false;
          select.value = option.value;
          const notice = section.querySelector('[data-enquiry-selection]');
          if (notice) notice.textContent = `${notice.dataset.selectionPrefix} ${option.textContent.trim()}`;
          return true;
        };
        let restored = false;
        try {
          if (state === 'success') sessionStorage.removeItem(storageKey);
          if (state === 'error') restored = selectTopic(sessionStorage.getItem(storageKey));
        } catch (_) {}
        if (!restored && state !== 'success' && select.selectedOptions[0]?.dataset.topicKey === 'general') {
          const params = new URLSearchParams(window.location.search);
          const workshop = params.get('workshop');
          const topic = params.get('topic');
          if (allowedWorkshops.has(workshop)) selectTopic(workshop);
          else if (topic === 'general' || topic === 'commissions') selectTopic(topic);
        }
        form.addEventListener('submit', () => {
          const key = select.selectedOptions[0]?.dataset.topicKey;
          try {
            if (allowedTopics.has(key)) sessionStorage.setItem(storageKey, key);
          } catch (_) {}
        });
        const result = section.querySelector('[data-enquiry-result]');
        if (result) {
          const focusResult = () => requestAnimationFrame(() => {
            if (document.activeElement === document.body || document.activeElement === section || document.activeElement === form) result.focus();
          });
          if (document.readyState === 'complete') focusResult();
          else window.addEventListener('load', focusResult, { once: true });
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
    else initialise();
    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ls-mobile-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = () => {
      document.querySelectorAll('.ls-mobile-menu').forEach((button) => {
        if (button.dataset.enhanced) return;
        const header = button.closest('m-header');
        const drawer = header.querySelector('#m-menu-drawer');
        const menu = header.megamenu;
        if (!drawer || !menu) return;
        button.dataset.enhanced = 'true';
        drawer.setAttribute('role', 'navigation');
        drawer.setAttribute('aria-label', button.dataset.navigationLabel);
        const mobile = window.matchMedia('(max-width: 1279px)');
        const open = () => drawer.classList.contains('open');
        let wasOpen = false;
        const sync = () => {
          const focusWasInside = drawer.contains(document.activeElement);
          const expanded = open();
          button.setAttribute('aria-expanded', String(expanded));
          button.setAttribute('aria-label', expanded ? button.dataset.closeLabel : button.dataset.menuLabel);
          drawer.inert = !expanded;
          drawer.setAttribute('aria-hidden', String(!expanded));
          drawer.querySelectorAll('.m-megamenu-mobile').forEach((panel) => {
            panel.inert = !panel.classList.contains('open');
          });
          const activePanel = [...drawer.querySelectorAll('.m-megamenu-mobile.open')].at(-1);
          drawer.querySelectorAll('a,button,input,select').forEach((element) => {
            element.inert = Boolean(activePanel && element.closest('.m-megamenu-mobile') !== activePanel);
          });
          drawer.querySelectorAll('.m-menu-mobile__toggle-button').forEach((toggle) => {
            toggle.setAttribute('aria-expanded', String(toggle.nextElementSibling.classList.contains('open')));
          });
          if (!expanded && wasOpen && mobile.matches && focusWasInside) button.focus({ preventScroll: true });
          wasOpen = expanded;
        };
        const openSubMenu = menu.openSubMenu.bind(menu);
        menu.openSubMenu = (panel, level) => {
          openSubMenu(panel, level);
          sync();
          panel.querySelector('.m-menu-mobile__back-button')?.focus({ preventScroll: true });
        };
        const closeSubMenu = menu.closeSubMenu.bind(menu);
        menu.closeSubMenu = (panel, level) => {
          closeSubMenu(panel, level);
          sync();
          panel.parentElement.querySelector('[data-toggle-submenu]')?.focus({ preventScroll: true });
        };
        const observer = new MutationObserver(sync);
        observer.observe(drawer, { attributes: true, attributeFilter: ['class'], subtree: true });
        document.addEventListener('keydown', (event) => {
          if (!mobile.matches || !open()) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            menu.closeMenu();
            button.focus({ preventScroll: true });
          }
          if (event.key !== 'Tab') return;
          const panels = [...drawer.querySelectorAll('.m-megamenu-mobile.open')];
          const currentPanel = panels.at(-1) || drawer;
          const links = [...currentPanel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,[tabindex="0"]')].filter((element) => {
            if (element.closest('[inert]')) return false;
            const rect = element.getBoundingClientRect();
            return rect.width > 0 && rect.height > 0 && getComputedStyle(element).visibility !== 'hidden';
          });
          const targets = [button, ...links];
          const first = targets[0];
          const last = targets.at(-1);
          const focused = document.activeElement;
          if (event.shiftKey && (focused === first || !targets.includes(focused))) {
            event.preventDefault();
            last.focus({ preventScroll: true });
          } else if (!event.shiftKey && (focused === last || !targets.includes(focused))) {
            event.preventDefault();
            first.focus({ preventScroll: true });
          }
        });
        mobile.addEventListener('change', () => {
          if (!mobile.matches && open()) menu.closeMenu();
        });
        const resetMenu = () => {
          if (!open()) return;
          drawer.classList.remove('open');
          drawer.querySelectorAll('.m-megamenu-mobile.open').forEach(panel => panel.classList.remove('open'));
          drawer.querySelector('.m-menu-mobile').classList.remove('m-submenu-open', 'm-submenu-open--level-1', 'm-submenu-open--level-2');
          drawer.querySelector('.m-menu-drawer__content').classList.remove('open-submenu');
          drawer.querySelector('.m-menu-drawer__wrapper').scrollLeft = 0;
          button.classList.remove('active');
          document.documentElement.classList.remove('prevent-scroll');
          wasOpen = false;
          sync();
        };
        window.addEventListener('pagehide', resetMenu);
        window.addEventListener('pageshow', resetMenu);
        sync();
      });
    };
    customElements.whenDefined('m-header').then(initialize);
    document.addEventListener('shopify:section:load', initialize);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ls-slide-image"] && !Shopify.designMode) return;
  try {
    (() => {
    const mobile = matchMedia('(max-width: 767px)');
    const update = () => document.querySelectorAll('.ls-slide-picture').forEach(picture => {
      const image = picture.querySelector('img');
      image.alt = mobile.matches ? picture.dataset.mobileAlt : picture.dataset.desktopAlt;
    });
    update();
    mobile.addEventListener('change', update);
    document.addEventListener('shopify:section:load', update);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ls-staged-slideshow"] && !Shopify.designMode) return;
  try {
    (() => {
    const ready = image => {
      if (!image) return Promise.resolve();
      if (image.complete) return image.decode().catch(() => {});
      return new Promise(resolve => {
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', resolve, { once: true });
      }).then(() => image.decode().catch(() => {}));
    };
    const setup = root => {
      if (root.dataset.stagedBound || !root.slider) return;
      root.dataset.stagedBound = 'true';
      const slider = root.slider;
      const autoplay = root.dataset.autoplay === 'true';
      let interacted = false;
      let painted = false;
      let pendingNavigation = 0;
      slider.autoplay?.stop();
      const hydrate = index => {
        const slides = Array.from(root.querySelectorAll('[data-slide]')).filter(slide => Number(slide.dataset.slide) === index);
        return Promise.all(slides.map(slide => {
          const template = slide.querySelector('template[data-ls-deferred-picture]');
          if (template) {
            const fragment = template.content.cloneNode(true);
            const image = fragment.querySelector('img');
            image.loading = 'eager';
            image.alt = matchMedia('(max-width: 767px)').matches ? image.parentElement.dataset.mobileAlt : image.parentElement.dataset.desktopAlt;
            template.replaceWith(fragment);
          }
          return ready(slide.querySelector('img'));
        }));
      };
      const indexes = [...new Set(Array.from(root.querySelectorAll('[data-slide]')).map(slide => Number(slide.dataset.slide)))];
      const hydrateAll = () => Promise.all(indexes.map(hydrate));
      const cancelAutoplay = () => {
        interacted = true;
        slider.autoplay?.stop();
      };
      root.addEventListener('click', event => {
        const target = event.target.closest('.m-slider-controls__button-next, .m-slider-controls__button-prev, .m-dot');
        if (!target) return;
        cancelAutoplay();
        event.preventDefault();
        event.stopImmediatePropagation();
        const count = indexes.length;
        let index;
        if (target.matches('.m-dot')) index = Array.from(target.parentElement.children).indexOf(target);
        else index = (slider.realIndex + (target.matches('.m-slider-controls__button-next') ? 1 : -1) + count) % count;
        const navigation = ++pendingNavigation;
        root.setAttribute('aria-busy', 'true');
        hydrate(index).then(() => {
          if (navigation !== pendingNavigation || !root.isConnected) return;
          root.removeAttribute('aria-busy');
          slider.slideToLoop(index);
        });
      }, true);
      slider.on('touchStart', () => {
        cancelAutoplay();
        hydrateAll();
      });
      slider.on('slideChange', () => hydrate(slider.realIndex));
      const first = root.querySelector('[data-slide="0"] img');
      ready(first).then(() => requestAnimationFrame(() => requestAnimationFrame(() => {
        if (!root.isConnected || painted) return;
        painted = true;
        root.dataset.firstImageReady = 'true';
        hydrateAll().then(() => {
          if (!root.isConnected) return;
          root.dataset.stagedImagesReady = 'true';
          if (autoplay && !interacted && !matchMedia('(prefers-reduced-motion: reduce)').matches) slider.autoplay?.start();
        });
      })));
    };
    const init = () => customElements.whenDefined('m-slideshow').then(() => {
      document.querySelectorAll('m-slideshow[data-staged-images]').forEach(setup);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ls-workshop-booking"] && !Shopify.designMode) return;
  try {
    function initialiseWorkshopBooking() {
    document.querySelectorAll('.ls-booking').forEach((booking) => {
      if (booking.dataset.bookingBound) return;
      booking.dataset.bookingBound = 'true';
      const page = booking.closest('.lwd') || booking;
      const dialog = booking.querySelector('dialog');
      if (!dialog) return;
      let trigger = null;
      const fallbackUrl = booking.dataset.bookingFallback;
      const openBooking = (button) => {
        try {
          if (typeof dialog.showModal !== 'function') {
            window.location.assign(fallbackUrl);
            return;
          }
          if (!dialog.open) dialog.showModal();
          trigger = button || trigger;
        } catch {
          window.location.assign(fallbackUrl);
        }
      };
      page.querySelectorAll('[data-booking-open]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          openBooking(button);
        });
      });
      dialog.querySelector('[data-booking-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => trigger?.focus({ preventScroll: true }));
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      const openFromHash = () => {
        if (window.location.hash === '#reserve' || window.location.hash === '#' + dialog.id) {
          openBooking(page.querySelector('[data-booking-open]'));
        }
      };
      window.addEventListener('hashchange', openFromHash);
      openFromHash();
      const form = dialog.querySelector('form');
      const submitButton = form?.querySelector('button[type="submit"]');
      if (form && submitButton) {
        const submitLabel = submitButton.textContent;
        let submitting = false;
        const resetSubmission = () => {
          submitting = false;
          submitButton.disabled = false;
          submitButton.textContent = submitLabel;
          form.removeAttribute('aria-busy');
        };
        form.addEventListener('submit', (event) => {
          if (event.defaultPrevented) return;
          if (submitting) {
            event.preventDefault();
            return;
          }
          submitting = true;
          submitButton.disabled = true;
          submitButton.textContent = submitButton.dataset.bookingLoadingLabel;
          form.setAttribute('aria-busy', 'true');
        });
        window.addEventListener('pageshow', resetSubmission);
      }
      if (window.location.hash === '#fees' || window.location.hash === '#booking-terms' || window.location.hash === '#travel') booking.scrollIntoView({ block: 'start' });
    });
  }
  initialiseWorkshopBooking();
  document.addEventListener('shopify:section:load', initialiseWorkshopBooking);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ls-workshop-gallery"] && !Shopify.designMode) return;
  try {
    function initialiseWorkshopGalleries() {
    document.querySelectorAll('[data-workshop-gallery]').forEach((gallery) => {
      if (gallery.dataset.galleryBound) return;
      gallery.dataset.galleryBound = 'true';
      const track = gallery.querySelector('.ls-workshop-gallery__track');
      const slides = Array.from(track.children);
      if (slides.length < 2) return;
      gallery.querySelector('.ls-workshop-gallery__controls').hidden = false;
      gallery.querySelector('[data-gallery-count]').textContent = slides.length;
      let current = 0;
      const move = (direction) => {
        current = (current + direction + slides.length) % slides.length;
        track.scrollTo({ left: current * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      gallery.querySelector('[data-gallery-prev]').addEventListener('click', () => move(-1));
      gallery.querySelector('[data-gallery-next]').addEventListener('click', () => move(1));
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      track.addEventListener('scroll', () => {
        current = Math.round(track.scrollLeft / track.clientWidth);
        gallery.querySelector('[data-gallery-current]').textContent = current + 1;
      }, { passive: true });
      new ResizeObserver(() => track.scrollTo({ left: current * track.clientWidth, behavior: 'instant' })).observe(track);
    });
  }
  initialiseWorkshopGalleries();
  document.addEventListener('shopify:section:load', initialiseWorkshopGalleries);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ls-workshop-moments"] && !Shopify.designMode) return;
  try {
    function initialiseWorkshopMoments(scope = document) {
    scope.querySelectorAll('[data-workshop-moments]').forEach((carousel) => {
      if (carousel.dataset.momentsBound) return;
      const track = carousel.querySelector('[data-moments-track]');
      const slides = [...carousel.querySelectorAll('[data-moments-slide]')];
      if (!track || slides.length < 2) return;
      carousel.dataset.momentsBound = 'true';
      const controls = carousel.querySelector('[data-moments-controls]');
      const toggle = carousel.querySelector('[data-moments-toggle]');
      const counter = carousel.querySelector('[data-moments-current]');
      const announcement = carousel.querySelector('[data-moments-announcement]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const events = new AbortController();
      const eventOptions = { signal: events.signal };
      const copies = slides.map((slide, index) => {
        slide.dataset.lsGalleryIndex = String(index);
        const copy = slide.cloneNode(true);
        copy.removeAttribute('data-moments-slide');
        copy.removeAttribute('aria-label');
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('data-moments-copy', '');
        copy.inert = false;
        copy.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => { element.tabIndex = -1; });
        copy.querySelectorAll('img').forEach((image) => { image.alt = ''; });
        track.append(copy);
        return copy;
      });
      let userPaused = reducedMotion.matches;
      let visible = false;
      let focusPaused = false;
      let interacting = false;
      let active = 0;
      let frame = 0;
      let resumeTimer = 0;
      let lastTime = 0;
      let position = track.scrollLeft;
      const loopWidth = () => copies[0].offsetLeft - slides[0].offsetLeft;
      const normalize = (value) => {
        const width = loopWidth();
        return width > 0 ? (value % width + width) % width : 0;
      };
      const updateCounter = () => {
        const left = normalize(track.scrollLeft);
        active = slides.reduce((nearest, slide, index) =>
          Math.abs(slide.offsetLeft - slides[0].offsetLeft - left) < Math.abs(slides[nearest].offsetLeft - slides[0].offsetLeft - left) ? index : nearest, 0);
        const label = String(active + 1);
        if (counter.textContent !== label) counter.textContent = label;
      };
      const stop = () => {
        window.cancelAnimationFrame(frame);
        window.clearTimeout(resumeTimer);
        frame = 0;
        resumeTimer = 0;
        lastTime = 0;
      };
      const canMove = () => !userPaused && visible && !focusPaused && !interacting && !document.hidden && !carousel.hasAttribute('data-ls-lightbox-open');
      const tick = (time) => {
        if (!canMove()) { stop(); return; }
        const elapsed = lastTime ? Math.min(time - lastTime, 64) : 0;
        lastTime = time;
        position = normalize(position + elapsed * 0.04);
        track.scrollLeft = position;
        updateCounter();
        frame = window.requestAnimationFrame(tick);
      };
      const schedule = (delay = 0) => {
        stop();
        toggle.textContent = userPaused ? carousel.dataset.playLabel : carousel.dataset.pauseLabel;
        if (!canMove()) return;
        if (delay) { resumeTimer = window.setTimeout(() => schedule(), delay); return; }
        position = normalize(track.scrollLeft);
        track.scrollLeft = position;
        frame = window.requestAnimationFrame(tick);
      };
      const moveTo = (index) => {
        stop();
        const target = (index + slides.length) % slides.length;
        const left = slides[target].offsetLeft - slides[0].offsetLeft;
        track.scrollTo({ left, behavior: reducedMotion.matches || target === 0 ? 'auto' : 'smooth' });
        announcement.textContent = carousel.dataset.countLabel.replace('__CURRENT__', String(target + 1));
        schedule(2600);
      };
      controls.hidden = false;
      carousel.querySelector('[data-moments-previous]').addEventListener('click', () => moveTo(active - 1), eventOptions);
      carousel.querySelector('[data-moments-next]').addEventListener('click', () => moveTo(active + 1), eventOptions);
      toggle.addEventListener('click', () => {
        userPaused = !userPaused;
        focusPaused = false;
        announcement.textContent = '';
        schedule();
      }, eventOptions);
      track.addEventListener('scroll', updateCounter, { ...eventOptions, passive: true });
      track.addEventListener('pointerdown', () => { interacting = true; stop(); }, { ...eventOptions, passive: true });
      const endInteraction = () => {
        if (!interacting) return;
        interacting = false;
        schedule(1800);
      };
      window.addEventListener('pointerup', endInteraction, eventOptions);
      window.addEventListener('pointercancel', endInteraction, eventOptions);
      track.addEventListener('wheel', (event) => {
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY) && !event.shiftKey) return;
        schedule(1800);
      }, { ...eventOptions, passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        const destination = { ArrowLeft: active - 1, ArrowRight: active + 1, Home: 0, End: slides.length - 1 }[event.key];
        if (destination === undefined) return;
        event.preventDefault();
        moveTo(destination);
      }, eventOptions);
      carousel.addEventListener('focusin', (event) => {
        focusPaused = event.target !== toggle && event.target.matches(':focus-visible');
        schedule();
      }, eventOptions);
      carousel.addEventListener('focusout', () => {
        window.queueMicrotask(() => {
          focusPaused = carousel.contains(document.activeElement) && document.activeElement !== toggle && document.activeElement.matches(':focus-visible');
          schedule();
        });
      }, eventOptions);
      carousel.addEventListener('ls:gallery-lightbox', () => schedule(), eventOptions);
      document.addEventListener('visibilitychange', () => { if (document.hidden) interacting = false; schedule(); }, eventOptions);
      reducedMotion.addEventListener('change', () => {
        if (reducedMotion.matches) userPaused = true;
        schedule();
      }, eventOptions);
      const observer = new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.2;
        schedule();
      }, { threshold: [0, 0.2] });
      observer.observe(track);
      const resizeObserver = new ResizeObserver(() => {
        track.scrollLeft = slides[active].offsetLeft - slides[0].offsetLeft;
        schedule();
      });
      resizeObserver.observe(track);
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(carousel)) return;
        stop();
        observer.disconnect();
        resizeObserver.disconnect();
        events.abort();
        copies.forEach((copy) => copy.remove());
        delete carousel.dataset.momentsBound;
      }, eventOptions);
      schedule();
    });
  }
  initialiseWorkshopMoments();
  document.addEventListener('shopify:section:load', (event) => initialiseWorkshopMoments(event.target));
  } catch(e) { console.error(e); }
})();

})();
